/* ═══════════════════════════════════════════════════
   NV – Ricerca nell'header («Il Liston»)
   Va insieme a snippets/nv-header-search.liquid e a
   sections/nv-search-suggest.liquid.

   Perché un file nostro e non assets/predictive-search.js di Horizon:
   - quello chiede a Shopify prodotti e collezioni (qui non esistono) e cerca
     solo nei titoli, quindi i suggerimenti erano sempre vuoti;
   - fa una richiesta a ogni pagina vista per disegnare uno stato vuoto che qui
     resta vuoto, non ha una lunghezza minima e non annulla davvero le
     richieste superate;
   - intercetta il Tab e non aggiorna aria-expanded né aria-activedescendant.

   Qui invece:
   - richiesta a /search/suggest con resources[type]=page,article,
     resources[options][fields]=title,body, limite 10 con limit_scope=each e
     section_id=nv-search-suggest (circa 2 kB compressi contro i 27 del .json);
   - minimo 2 lettere, 250 ms di pausa, cache per parola, AbortController
     passato davvero a fetch, nessuna richiesta al caricamento della pagina;
   - «Vai a» e «Accesso rapido» sono righe già scritte nella pagina dentro due
     <template>: compaiono a ogni tasto, senza aspettare il server;
   - combobox completa: aria-expanded, aria-controls, aria-activedescendant,
     role=option, e il Tab non viene toccato (le righe hanno tabindex=-1).

   Niente HTML costruito a mano con quello che scrive la persona: i risultati
   arrivano già stampati da Liquid (con escape) e l'evidenziazione delle voci
   «Vai a» si fa spezzando i nodi di testo, mai con innerHTML.
   ═══════════════════════════════════════════════════ */
(function () {
  'use strict';

  if (window.nvSiteSearchReady) return;
  window.nvSiteSearchReady = true;

  var SEZIONE = 'nv-search-suggest';
  var MIN_LETTERE = 2;
  var PAUSA = 250;
  var MAX_VAI_A = 3;
  var CACHE_MAX = 30;

  var cache = new Map();
  var istanze = [];
  var numero = 0;
  var movimentoRidotto = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Minuscole senza accenti, con la stessa lunghezza del testo di partenza:
     serve per confrontare e per sapere dove evidenziare. */
  function piatta(s) {
    return String(s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '');
  }

  function parole(s) {
    return piatta(s).split(/[^a-z0-9àèéìòù]+/).filter(Boolean);
  }

  /* Quanto una riga «Vai a» somiglia a quello che si sta scrivendo.
     Perdona l'errore in fondo alla parola («cittadinanaza» → «cittadinanza»),
     che è quello che capita scrivendo in fretta. */
  function punteggio(chiavi, q) {
    var migliore = 0;
    for (var i = 0; i < chiavi.length; i++) {
      var k = chiavi[i];
      if (k.indexOf(q) === 0) {
        migliore = Math.max(migliore, q.length === k.length ? 4 : 3);
      } else if (q.length >= 4 && k.indexOf(q.slice(0, -1)) === 0) {
        migliore = Math.max(migliore, 2);
      } else if (q.length >= 5 && k.indexOf(q.slice(0, -2)) === 0) {
        migliore = Math.max(migliore, 1);
      }
    }
    return migliore;
  }

  /* Evidenzia la parola cercata dentro un elemento, spezzando il nodo di
     testo: nessun innerHTML, quindi niente da sfuggire. */
  function evidenzia(el, q) {
    if (!el || !q) return;
    var testo = el.textContent;
    var piano = piatta(testo);
    if (piano.length !== testo.length) return;
    var i = piano.indexOf(piatta(q));
    if (i < 0) return;
    var mark = document.createElement('mark');
    mark.className = 'nv-ss-mk';
    mark.textContent = testo.slice(i, i + q.length);
    el.textContent = '';
    if (i > 0) el.appendChild(document.createTextNode(testo.slice(0, i)));
    el.appendChild(mark);
    if (i + q.length < testo.length) el.appendChild(document.createTextNode(testo.slice(i + q.length)));
  }

  function plurale(n, uno, molti) {
    return n === 1 ? uno : molti;
  }

  /* ─────────── una istanza: la barra oppure il foglio del telefono ─────────── */
  function Ricerca(radice) {
    var self = this;
    this.radice = radice;
    this.posto = radice.getAttribute('data-nv-ss-place') || 'bar';
    this.campo = radice.querySelector('[data-nv-ss-field]');
    this.input = radice.querySelector('[data-nv-ss-input]');
    this.pannello = radice.querySelector('[data-nv-ss-panel]');
    this.lista = radice.querySelector('[data-nv-ss-list]');
    this.piede = radice.querySelector('[data-nv-ss-foot]');
    this.conteggio = radice.querySelector('[data-nv-ss-count-text]');
    this.voce = radice.querySelector('[data-nv-ss-live]');
    this.cancella = radice.querySelector('[data-nv-ss-clear]');
    this.foglio = radice.querySelector('[data-nv-ss-sheet]');
    this.apri = radice.querySelector('[data-nv-ss-open]');
    this.chiudi = radice.querySelector('[data-nv-ss-close]');
    if (!this.input || !this.pannello || !this.lista) return;

    this.prefisso = 'nv-ss-' + ++numero;
    this.maxPagine = parseInt(radice.getAttribute('data-max-pages'), 10) || 3;
    this.maxArticoli = parseInt(radice.getAttribute('data-max-articles'), 10) || 4;
    this.opzioni = [];
    this.attiva = -1;
    this.timer = null;
    this.timerVoce = null;
    this.richiesta = null;
    this.ultimo = null; // { q: '…', nodo: <fragment> }

    if (radice.getAttribute('data-meta') === '0') radice.classList.add('nv-ss--nometa');
    if (radice.getAttribute('data-ctx') === '0') radice.classList.add('nv-ss--noctx');

    this.lista.id = this.prefisso + '-lista';
    this.input.setAttribute('aria-controls', this.lista.id);

    this.input.addEventListener('input', function () {
      self.scritto();
    });
    this.input.addEventListener('focus', function () {
      if (self.posto === 'bar') self.mostra();
    });
    this.input.addEventListener('keydown', function (e) {
      self.tasto(e);
    });

    if (this.cancella) {
      this.cancella.addEventListener('click', function () {
        self.svuota();
      });
    }

    // Invio senza nessuna riga scelta: il form va da solo su /search.
    var form = this.input.form;
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!self.input.value.trim()) e.preventDefault();
      });
    }

    if (this.posto === 'bar') {
      // Il clic fuori chiude; il focus che se ne va anche, ma solo se è uscito
      // davvero dalla ricerca (i link del pannello stanno dentro).
      document.addEventListener('pointerdown', function (e) {
        if (!radice.contains(e.target)) self.nascondi();
      });
      radice.addEventListener('focusout', function (e) {
        if (!e.relatedTarget || !radice.contains(e.relatedTarget)) self.nascondi();
      });
      window.addEventListener('resize', function () {
        self.misura();
      });
    }

    if (this.foglio && this.apri) {
      this.apri.setAttribute('aria-haspopup', 'dialog');
      this.apri.form &&
        this.apri.form.addEventListener('submit', function (e) {
          // Senza JavaScript questo invio porta alla pagina dei risultati:
          // è il ripiego. Con il JavaScript si apre il foglio.
          e.preventDefault();
          self.apriFoglio();
        });
      if (this.chiudi) {
        this.chiudi.addEventListener('click', function () {
          self.chiudiFoglio();
        });
      }
      this.foglio.addEventListener('close', function () {
        document.documentElement.classList.remove('nv-ss-lock');
        if (self.apri) self.apri.focus();
      });
    }

    istanze.push(this);
  }

  Ricerca.prototype.visibile = function () {
    return !!(this.radice.offsetWidth || this.radice.offsetHeight || this.radice.getClientRects().length);
  };

  /* Distanza fra il fondo del campo e la linea oro: dipende dalle impostazioni
     di altezza delle righe, quindi si misura invece di indovinarla. Il valore
     sta sul pannello (nodo interno) e non sul contenitore, che morph
     risincronizza a ogni idratazione dell'header. */
  Ricerca.prototype.misura = function () {
    if (this.posto !== 'bar') return;
    var header = this.radice.closest('header-component') || document.getElementById('header-component');
    if (!header) return;
    var giu = header.getBoundingClientRect().bottom - this.radice.getBoundingClientRect().bottom;
    if (!isFinite(giu) || giu < 0) giu = 0;
    this.pannello.style.setProperty('--nv-ss-gap', Math.round(giu) + 8 + 'px');
  };

  Ricerca.prototype.mostra = function () {
    this.misura();
    this.pannello.hidden = false;
    this.input.setAttribute('aria-expanded', 'true');
    this.disegna();
  };

  Ricerca.prototype.nascondi = function () {
    if (this.posto !== 'bar') return;
    this.pannello.hidden = true;
    this.input.setAttribute('aria-expanded', 'false');
    this.input.removeAttribute('aria-activedescendant');
    this.attiva = -1;
  };

  Ricerca.prototype.apriFoglio = function () {
    if (!this.foglio) return;
    document.documentElement.classList.add('nv-ss-lock');
    if (typeof this.foglio.showModal === 'function') this.foglio.showModal();
    else this.foglio.setAttribute('open', '');
    this.pannello.hidden = false;
    this.input.setAttribute('aria-expanded', 'true');
    this.disegna();
    this.input.focus();
  };

  Ricerca.prototype.chiudiFoglio = function () {
    if (!this.foglio) return;
    if (typeof this.foglio.close === 'function') this.foglio.close();
    else {
      this.foglio.removeAttribute('open');
      document.documentElement.classList.remove('nv-ss-lock');
      if (this.apri) this.apri.focus();
    }
  };

  Ricerca.prototype.svuota = function () {
    this.input.value = '';
    this.ultimo = null;
    this.scritto();
    this.input.focus();
  };

  Ricerca.prototype.scritto = function () {
    var self = this;
    var q = this.input.value.trim();
    if (this.cancella) this.cancella.hidden = q.length === 0;
    if (this.posto === 'bar' && this.pannello.hidden) this.mostra();

    // Le scorciatoie si vedono subito, a ogni tasto: non aspettano il server.
    this.disegna();

    if (this.timer) clearTimeout(this.timer);
    if (q.length < MIN_LETTERE) {
      if (this.richiesta) this.richiesta.abort();
      this.ultimo = null;
      return;
    }

    var chiave = piatta(q);
    if (cache.has(chiave)) {
      this.ricevuto(q, cache.get(chiave));
      return;
    }

    this.timer = setTimeout(function () {
      self.chiedi(q, chiave);
    }, PAUSA);
  };

  Ricerca.prototype.chiedi = function (q, chiave) {
    var self = this;
    if (this.richiesta) this.richiesta.abort();
    var controllo = new AbortController();
    this.richiesta = controllo;

    var url =
      '/search/suggest?q=' +
      encodeURIComponent(q) +
      '&resources[type]=page,article' +
      '&resources[options][fields]=title,body' +
      '&resources[limit]=10&resources[limit_scope]=each' +
      '&section_id=' +
      SEZIONE;

    fetch(url, { signal: controllo.signal, headers: { Accept: 'text/html' } })
      .then(function (r) {
        if (!r.ok) throw new Error('risposta ' + r.status);
        return r.text();
      })
      .then(function (testo) {
        if (cache.size >= CACHE_MAX) cache.delete(cache.keys().next().value);
        cache.set(chiave, testo);
        if (self.input.value.trim() === q) self.ricevuto(q, testo);
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        // Se il server non risponde restano le scorciatoie e l'Invio, che
        // porta comunque alla pagina dei risultati: nessun vicolo cieco.
      });
  };

  Ricerca.prototype.ricevuto = function (q, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var carico = doc.querySelector('[data-nv-ss-payload]');
    if (!carico) return;
    var via = carico.querySelectorAll('script,style,iframe,object');
    for (var i = 0; i < via.length; i++) via[i].remove();
    this.ultimo = { q: q, nodo: document.importNode(carico, true) };
    this.disegna();
  };

  /* Ridisegna tutto il pannello: scorciatoie (subito) più, se è arrivata e
     riguarda quello che c'è scritto adesso, la risposta del server. */
  Ricerca.prototype.disegna = function () {
    var q = this.input.value.trim();
    var lista = this.lista;
    var piede = this.piede;
    lista.textContent = '';
    if (piede) piede.textContent = '';

    var righe = 0;
    var pagine = 0;
    var articoli = 0;
    var trovati = 0; // tutto quello che ha trovato Shopify, non solo le righe mostrate
    var vaiA = 0;

    if (q.length === 0) {
      vaiA = this.gruppo('Accesso rapido', this.righeRapide(), null);
      righe = vaiA;
      this.scrivi(vaiA ? 'Accesso rapido' : '');
    } else {
      vaiA = this.gruppo('Vai a', this.righeVaiA(q), null);
      righe = vaiA;

      var carico = this.ultimo && this.ultimo.q === q ? this.ultimo.nodo : null;
      if (carico) {
        var corpo = carico.querySelector('[data-nv-ss-body]');
        if (corpo) {
          var gruppi = corpo.querySelectorAll('[data-nv-ss-group]');
          for (var i = 0; i < gruppi.length; i++) {
            var g = gruppi[i];
            var tipo = g.getAttribute('data-nv-ss-group');
            var tetto = tipo === 'pages' ? this.maxPagine : this.maxArticoli;
            var tutte = g.querySelectorAll('[data-nv-ss-opt]');
            var visti = Math.min(tutte.length, tetto);
            for (var j = tetto; j < tutte.length; j++) tutte[j].remove();
            var cont = g.querySelector('[data-nv-ss-count]');
            if (cont) cont.textContent = tutte.length > visti ? visti + ' di ' + tutte.length : '';
            g.setAttribute(
              'aria-label',
              g.getAttribute('data-label') + (tutte.length > visti ? ', ' + visti + ' di ' + tutte.length : '')
            );
            lista.appendChild(g);
            righe += visti;
            trovati += tutte.length;
            if (tipo === 'pages') pagine = visti;
            else articoli = visti;
          }
        }

        var niente = carico.querySelector('[data-nv-ss-none]');
        if (niente && piede) {
          this.forseCercavi(niente, q);
          piede.appendChild(niente);
        }
        var tutti = carico.querySelector('[data-nv-ss-all]');
        if (tutti && piede) piede.appendChild(tutti);

        this.scrivi(trovati + ' ' + plurale(trovati, 'risultato', 'risultati') + ' per «' + q + '»');
        this.annuncia(vaiA, pagine, articoli, q, trovati);
      } else {
        this.scrivi(vaiA ? 'Scorciatoie' : 'Sto cercando…');
      }
    }

    this.numera();
    if (righe === 0 && q.length === 0) this.pannello.hidden = this.posto === 'bar';
  };

  Ricerca.prototype.scrivi = function (testo) {
    if (this.conteggio) this.conteggio.textContent = testo;
  };

  /* La regione di stato è fissa e fuori dalla lista, così l'annuncio parte
     davvero. Un filo di ritardo evita di leggere a ogni lettera. */
  Ricerca.prototype.annuncia = function (vaiA, pagine, articoli, q, trovati) {
    var self = this;
    if (!this.voce) return;
    if (this.timerVoce) clearTimeout(this.timerVoce);
    this.timerVoce = setTimeout(
      function () {
        var frasi = [];
        if (trovati === 0) frasi.push('Nessun risultato per ' + q);
        else frasi.push(trovati + ' ' + plurale(trovati, 'risultato', 'risultati') + ' per ' + q);
        if (vaiA) frasi.push(vaiA + ' ' + plurale(vaiA, 'scorciatoia', 'scorciatoie'));
        if (pagine) frasi.push(pagine + ' ' + plurale(pagine, 'pagina mostrata', 'pagine mostrate'));
        if (articoli) frasi.push(articoli + ' ' + plurale(articoli, 'articolo mostrato', 'articoli mostrati'));
        if (vaiA + pagine + articoli) frasi.push('Usa le frecce per scegliere');
        self.voce.textContent = frasi.join('. ') + '.';
      },
      300
    );
  };

  /* Crea il gruppo e ci mette dentro le righe. Torna quante ne ha messe. */
  Ricerca.prototype.gruppo = function (titolo, righe, contatore) {
    if (!righe.length) return 0;
    var g = document.createElement('div');
    g.className = 'nv-ss-g';
    g.setAttribute('role', 'group');
    g.setAttribute('aria-label', titolo);
    var h = document.createElement('div');
    h.className = 'nv-ss-gh';
    h.setAttribute('aria-hidden', 'true');
    h.textContent = titolo;
    if (contatore) {
      var n = document.createElement('span');
      n.className = 'nv-ss-n';
      n.textContent = contatore;
      h.appendChild(document.createTextNode(' '));
      h.appendChild(n);
    }
    g.appendChild(h);
    for (var i = 0; i < righe.length; i++) g.appendChild(righe[i]);
    this.lista.appendChild(g);
    return righe.length;
  };

  Ricerca.prototype.righeRapide = function () {
    var t = document.querySelector('template[data-nv-ss-quick]');
    if (!t) return [];
    return Array.prototype.slice.call(t.content.cloneNode(true).querySelectorAll('[data-nv-ss-opt]'));
  };

  Ricerca.prototype.righeVaiA = function (q) {
    var t = document.querySelector('template[data-nv-ss-goto]');
    if (!t || q.length < MIN_LETTERE) return [];
    var qp = piatta(q);
    var fuori = [];
    var voci = t.content.cloneNode(true).querySelectorAll('[data-nv-ss-opt]');
    for (var i = 0; i < voci.length; i++) {
      var p = punteggio(parole(voci[i].getAttribute('data-k') || ''), qp);
      if (p > 0) fuori.push({ p: p, i: i, el: voci[i] });
    }
    fuori.sort(function (a, b) {
      return b.p - a.p || a.i - b.i;
    });
    fuori = fuori.slice(0, MAX_VAI_A);
    var righe = [];
    for (var j = 0; j < fuori.length; j++) {
      evidenzia(fuori[j].el.querySelector('[data-nv-ss-title]'), q);
      righe.push(fuori[j].el);
    }
    return righe;
  };

  /* «Forse cercavi»: la parola giusta viene dalle stesse scorciatoie, quindi
     non costa nessuna richiesta. */
  Ricerca.prototype.forseCercavi = function (blocco, q) {
    var riga = blocco.querySelector('[data-nv-ss-did]');
    var bottone = blocco.querySelector('[data-nv-ss-did-btn]');
    if (!riga || !bottone) return;
    var t = document.querySelector('template[data-nv-ss-goto]');
    if (!t) return;
    var qp = piatta(q);
    var meglio = null;
    var voci = t.content.querySelectorAll('[data-nv-ss-opt]');
    for (var i = 0; i < voci.length; i++) {
      var chiavi = parole(voci[i].getAttribute('data-k') || '');
      var p = punteggio(chiavi, qp);
      if (p > 0 && p < 4 && (!meglio || p > meglio.p)) {
        meglio = { p: p, parola: voci[i].getAttribute('data-sug') || chiavi[0] };
      }
    }
    if (!meglio) return;
    var self = this;
    bottone.textContent = meglio.parola;
    riga.hidden = false;
    bottone.addEventListener('click', function () {
      self.input.value = meglio.parola;
      self.input.focus();
      self.scritto();
    });
  };

  /* Gli id li mette il JS con un prefisso per istanza: la barra e il foglio del
     telefono stanno nella stessa pagina e la sezione non ne stampa nessuno. */
  Ricerca.prototype.numera = function () {
    this.opzioni = Array.prototype.slice.call(this.lista.querySelectorAll('[data-nv-ss-opt]'));
    for (var i = 0; i < this.opzioni.length; i++) {
      var o = this.opzioni[i];
      o.id = this.prefisso + '-o-' + i;
      o.setAttribute('role', 'option');
      o.setAttribute('aria-selected', 'false');
      o.setAttribute('tabindex', '-1');
      o.classList.remove('nv-ss-o--on');
    }
    this.attiva = -1;
    this.input.removeAttribute('aria-activedescendant');
  };

  Ricerca.prototype.scegli = function (i) {
    if (!this.opzioni.length) return;
    if (this.attiva >= 0 && this.opzioni[this.attiva]) {
      this.opzioni[this.attiva].classList.remove('nv-ss-o--on');
      this.opzioni[this.attiva].setAttribute('aria-selected', 'false');
    }
    if (i < 0) i = this.opzioni.length - 1;
    if (i >= this.opzioni.length) i = 0;
    this.attiva = i;
    var o = this.opzioni[i];
    o.classList.add('nv-ss-o--on');
    o.setAttribute('aria-selected', 'true');
    this.input.setAttribute('aria-activedescendant', o.id);
    if (o.scrollIntoView) {
      o.scrollIntoView({ block: 'nearest', behavior: movimentoRidotto.matches ? 'auto' : 'smooth' });
    }
  };

  Ricerca.prototype.tasto = function (e) {
    if (e.altKey || e.ctrlKey || e.metaKey) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (this.pannello.hidden) this.mostra();
      this.scegli(this.attiva + 1);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (this.pannello.hidden) this.mostra();
      this.scegli(this.attiva - 1);
    } else if (e.key === 'Enter') {
      // Nessuna riga è scelta di suo: senza frecce l'Invio porta alla pagina
      // dei risultati, anche quando il risultato è uno solo.
      if (this.attiva >= 0 && this.opzioni[this.attiva]) {
        e.preventDefault();
        window.location.href = this.opzioni[this.attiva].href;
      }
    } else if (e.key === 'Escape') {
      // Standard: il primo Esc chiude e lascia quello che hai scritto, il
      // secondo svuota. Il foglio del telefono si chiude al primo Esc: lo
      // chiudiamo noi, senza contare sul <dialog>, che dopo tasti ravvicinati
      // può ignorare l'Esc (il tasto indietro di Android lo gestisce lui).
      if (this.posto !== 'bar') {
        e.preventDefault();
        this.chiudiFoglio();
      } else {
        if (!this.pannello.hidden) {
          e.preventDefault();
          this.nascondi();
        } else if (this.input.value) {
          e.preventDefault();
          this.svuota();
        }
      }
    }
  };

  /* ─────────── avvio ─────────── */
  function avvia() {
    var nodi = document.querySelectorAll('[data-nv-ss]');
    for (var i = 0; i < nodi.length; i++) {
      if (nodi[i].nvSs) continue;
      nodi[i].nvSs = true;
      new Ricerca(nodi[i]);
    }
  }

  /* Ctrl+K, Cmd+K e «/» aprono la ricerca che si vede (barra sul computer,
     foglio sul telefono). Ignorati dentro i campi di testo. */
  document.addEventListener('keydown', function (e) {
    var k = e.key;
    var scorciatoia = (k === 'k' || k === 'K') && (e.ctrlKey || e.metaKey);
    var barra = k === '/' && !e.ctrlKey && !e.metaKey && !e.altKey;
    if (!scorciatoia && !barra) return;
    var a = document.activeElement;
    if (a && (a.isContentEditable || /^(input|textarea|select)$/i.test(a.tagName))) return;
    for (var i = 0; i < istanze.length; i++) {
      var r = istanze[i];
      if (!r.visibile()) continue;
      e.preventDefault();
      if (r.posto === 'mobile') r.apriFoglio();
      else {
        r.input.focus();
        r.mostra();
      }
      return;
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
  else avvia();
})();
